/**
 * @generated SignedSource<<f005ee38313ff3feef7b8567f2274008>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerDetailsHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedNewSellerPill_viewer">;
  readonly " $fragmentType": "PdpSharedSellerDetailsHeader_viewer";
};
export type PdpSharedSellerDetailsHeader_viewer$key = {
  readonly " $data"?: PdpSharedSellerDetailsHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerDetailsHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedNewSellerPill_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "64cd5dbaaf27f11721fa5d5353998667";

export default node;
